import React, { useEffect, useState } from 'react';
import { getProductFormats } from '../api/settingsApi';

export default function CategoryFormatSelector({ value, onChange, disabled }) {
  const [formats, setFormats] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [retry, setRetry] = useState(0);
  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError('');
    const load = async () => {
      try {
        const response = await getProductFormats({ activeOnly: 'false' });
        if (!Array.isArray(response?.formats)) throw new Error('Invalid formats');
        if (!cancelled) setFormats(response.formats);
      } catch {
        if (!cancelled) setError('No se pudieron cargar los formatos. La selección guardada se conservará.');
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    load();
    return () => { cancelled = true; };
  }, [retry]);

  const active = formats.filter((format) => format.isActive !== false);
  const selected = value ?? active.map((format) => Number(format.id));
  const visible = formats.filter((format) => format.isActive !== false || selected.includes(Number(format.id)));
  return <fieldset className="rounded-2xl border border-gray-200 p-4" disabled={disabled}>
    <legend className="px-1 text-sm font-semibold text-gray-950">Formatos de nuevas variedades</legend>
    <p className="mt-1 text-xs leading-relaxed text-gray-600">Al crear una variedad de esta categoría se prellenará una presentación de cada formato seleccionado. Las presentaciones existentes se conservan.</p>
    {loading ? <p role="status" className="mt-3 text-sm text-gray-500">Cargando formatos...</p> : error ?
      <p role="alert" className="mt-3 text-sm text-red-700">{error} <button type="button" onClick={() => setRetry((current) => current + 1)} className="font-semibold underline">Reintentar formatos</button></p> : <>
        <div className="mt-3 flex gap-4 text-xs font-semibold text-blue-700">
          <button type="button" onClick={() => onChange(active.map((format) => Number(format.id)))}>Seleccionar todos</button>
          <button type="button" onClick={() => onChange([])}>Ninguno</button>
        </div>
        <div className="mt-3 grid gap-2 sm:grid-cols-2">
          {visible.map((format) => <label key={format.id} className="flex items-center gap-3 rounded-xl border border-gray-200 bg-gray-50 px-3 py-3 text-sm text-gray-700">
            <input type="checkbox" checked={selected.includes(Number(format.id))}
              onChange={(event) => onChange(event.target.checked ? [...selected, Number(format.id)] : selected.filter((id) => id !== Number(format.id)))}
              className="accent-blue-600" />
            {format.name}{format.isActive === false ? ' (inactivo; no se prellena)' : ''}
          </label>)}
        </div>
        {!active.some((format) => selected.includes(Number(format.id))) && <p className="mt-3 text-xs text-gray-500">No se prellenarán formatos. Podrás añadir presentaciones manualmente.</p>}
      </>}
  </fieldset>;
}
